import React, { Component } from "react";
import { Route, HashRouter } from "react-router-dom";

import Footer from "./footer/Footer";
import NavigationBar from "./navigationbar/NavigationBar";

import Home from "../home/Home";
import Filmes from "../filmes/Filmes";
import Novidades from "../novidades/Novidades";
import QuemSomos from "../quemsomos/QuemSomos";

import "./pageStruct.css";


class PageStruct extends Component {

    /**
     * This method render the information (data from previous functions) with HTML code
     * @returns Return page information inside HTML
     */
    render() {
        return(
            <div className="mainApp">
                <div className="projectNameLeft">
                    <h1>Filmes e Séries - Conteúdos Online</h1>
                </div>

                <HashRouter>
                    <NavigationBar /> {/* Insert/Add the navigation bar */}

                    <div className="content"> {/* Place where all the information show */}
                        <Route exact path="/" component={Home} />
                        <Route exact path="/filmes" component={Filmes} />
                        <Route exact path="/novidades" component={Novidades} />
                        <Route exact path="/quemsomos" component={QuemSomos} />

                    </div>

                    <Footer />
                </HashRouter>
            </div>
        );
    }
}

export default PageStruct;
